import React from 'react'
import { Link } from 'react-router-dom'
import { toTitleCase } from '../../services/helpers/helpers'
import Layout from '../../layout'
import PageHeader from '../../components/layout_components/PageHeader'
import { homePageAssets } from '../../assets/media'
import StyledButton from '../../components/layout_components/StyledButton'
import Carousel from '../../components/pages_components/home/carousel/Carousel'
import CustomImageSlider from '../../components/layout_components/Slider'
// import TestimonialSlider from '../../components/pages_components/home/TestimonialSlider'
import Stepper from '../../components/pages_components/home/Stepper'
import CustomTestimonialsComponent from '../../components/pages_components/home/CustomTestimonialComponent'

import { IoGameController } from "react-icons/io5"
import { TiWorld } from "react-icons/ti"
import { FaUserAlt } from "react-icons/fa"
import { FaHandshake } from "react-icons/fa"
import TestimonialsCarousel from '../../components/pages_components/home/testimonialsCarousel/Carousel'


const {
  person,
  curvedProcessMobile,
  brandBannerMobile,
  brandsBanner,
  curvedProcess,
  upperFooterArt,
} = homePageAssets

const { ba, ca, at } = homePageAssets.assessments
const { bannerArt } = homePageAssets.stats
const { image1, image2, image3, image4, image5, image6, image7, image8, image9 } = homePageAssets.brandSlides


const Home = () => {
  const homeContent = [
    {
      name: "Behavioral Assessments",
      value: "These are situational judgement tests (SJTs) that put candidates in a relevant real-life work scenarios to assess their competency levels and specific function skills.",
      imgSrc: ba
    },
    {
      name: "Cognitive Ability Games",
      value: "These are short neuroscience-based games that assess the cognitive abilities of candidates that together provides a snapshot of a person’s unique capabilities.",
      imgSrc: ca

    },
    {
      name: "Aptitude Tests",
      value: "These tests assess a candidate’s verbal comprehension, inductive and logical reasoning, as well as their decision making and time management skills.",
      imgSrc: at

    },
  ]

  const brandsSlides = [
    image1,
    image2,
    image3,
    image4,
    image5,
    image6,
    image7,
    image8,
    image9,
  ]


  const statsData = [
    {
      name: "Candidate Assessments",
      value: "750,000+",
      imgSrc: <IoGameController className='w-[1.5rem] h-[1.5rem] 2xl:mr-2 lg:mr-1 text-[#ffe501] hidden lg:block' />,
      imgSrc2: <IoGameController className='w-[55px] h-[68px] mx-auto text-[#ffe501] lg:hidden' />
    },
    {
      name: "Global Clients",
      value: "50+",
      imgSrc: <FaUserAlt className='text-[1.2rem] 2xl:mr-2 lg:mr-1 text-[#ffe501] hidden lg:block' />,
      imgSrc2: <FaUserAlt className='w-[55px] h-[68px] mx-auto text-[#ffe501] lg:hidden' />
    },
    {
      name: "Countries",
      value: "170+ ",
      imgSrc: <TiWorld className='w-[1.5rem] h-[1.5rem] 2xl:mr-2 lg:mr-1 text-[#ffe501]  hidden lg:block' />,
      imgSrc2: <TiWorld className='w-[55px] h-[68px] mx-auto text-[#ffe501] lg:hidden' />
    },
    {
      name: "Partners",
      value: "10+",
      imgSrc: <FaHandshake className='w-[1.5rem] h-[1.5rem] 2xl:mr-2 lg:mr-1 text-[#ffe501] hidden lg:block' />,
      imgSrc2: <FaHandshake className='w-[55px] h-[68px] mx-auto text-[#ffe501] lg:hidden' />
    },
  ]


  return (

    <Layout>
      <div className="home mt-5">

        {/* section 1 */}
        <div className="section1 sm:w-[40rem]  lg:w-[80vw] mx-auto">


          <PageHeader titleText={"Ready-to-Launch Gamified Tests"} />

          <div className="columns lg:flex mt-20">
            <div className="col1 lg:w-[35rem] w-[20rem] mx-auto xl:w-[42rem] 2xl:w-[40rem] my-auto">

              {
                homeContent.map((item, index) =>
                (

                  <div key={`divItem${item.name + index}`} className="item  sm:mt-0 flex flex-col  lg:flex-row items-center text-xs p-2 mt-8 lg:mt-2 2xl:w-[500px] lg:mx-auto">
                    <div className="left lg:mr-4 xl:mr-3 2xl:mr-4">
                      <img className='h-[4.5rem] sm:h-[6rem] lg:object-contain lg:w-[13rem] xl:w-[15rem] xl:h-[4rem] 2xl:w-[80px] 2xl:h-[80px]' src={item.imgSrc} alt="" />
                    </div>
                    <div className="right ml-4 text-center lg:text-left mt-5 sm:mt-0">
                      <h3 className='text-sm font-bold text-[18px] sm:font-semibold 2xl:text-[22px] 2xl:leading-[25px] 2xl:font-[700]'>
                        {item.name}
                      </h3>
                      <p className='lg:text-[9px] xl:text-[13px] 2xl:text-[17px] 2xl:leading-[25px] 2xl:w-[368px] mt-3 sm:mt-5'>
                        {item.value}
                      </p>
                    </div>
                  </div>


                )
                )
              }


            </div>
            <div className="col2 w-[35rem] hidden lg:block  lg:w-[50rem] lg:flex lg:items-start">
              <img className='person mt-10 object-contain lg:h-[27rem] xl:h-[30rem] 2xl:h-[40rem]' src={person} alt="" />
              <CustomImageSlider customImgStyle="hidden lg:block lg:w-[22rem]   2xl:w-[30vw]" />
            </div>

          </div>

          <div className="button flex justify-center my-16 sm:my-20">
            <Link to="/plans">

              <StyledButton btnText={"SEE PRICING"} customStyle="w-[12rem] font-[600] text-sm xl:w-[11rem] !py-2 sm:w-[20rem] lg:w-[12rem] cursor-pointer bg-[#ffd700] !text-[#333333] xl:h-[2rem] semi-bold 2xl:font-semibold text-red-500 2xl:!w-[20rem] " />
            </Link>
          </div>



        </div>

        {/* banner 1 */}

        <div className="statsBanner bg-[#333333] relative">

          <div className="bannerWrapper sm:w-[40rem]  lg:w-[87vw] mx-auto  flex flex-col sm:flex-col sm:flex-wrap sm:justify-around  lg:flex-row  lg:items-center py-16 sm:py-6 items-center xl:h-[210px] 2xl:h-[334px] lg:justify-evenly">

            <div className="tagLine sm:font-bold sm:text-[#FFD700] text-white w-[310px] font-[500] leading-[44px] ml-5 text-center lg:text-left xl:text-[30px] xl:leading-[40px] xl:font-semibold 2xl:!text-[36px] 2xl:leading-[44px] 2xl:font-[500] 2xl:w-[380px] lg:w-[200px] xl:w-[300px]">
              <p className='text-[#FFD700] text-[24px] lg:text-[18px] xl:text-[28px] 2xl:text-[34px] 2xl:font-[600]'>{toTitleCase("We’re a world leader in gamified tests")}</p>
            </div>

            <div className="numbers flex w-full  flex-col sm:w-fit items-center mt-5 sm:mt-5 sm:p-2 lg:flex-row lg:p-0 lg:mt-0 ">

              {
                statsData.map((item, index) => (
                  <div key={`divStats${item.name + index}`} className={`widget text-white lg:p-0 w-full lg:w-[6rem] text-center xl:w-[12rem]  2xl:w-[14rem] ${item.value !== "750,000+" && "sm:!w-[9rem] w-full lg:!w-[6rem] 2xl:!w-[8.5rem] xl:!w-[8rem]"} ${item.value === "750,000+" && '2xl:!w-[15rem] xl:!w-[14rem] lg:!w-[12rem]'} lg:mx-[0.5rem] xl:mx-[1rem] 2xl:mx-[2rem] mt-10 sm:mt-8 sm:m-2 lg:m-0`}>

                    <div className="icon mb-2 sm:mb-0 w-[70px] h-[63px] sm:w-[73px] sm:h-[68px] mx-auto lg:hidden">
                      {item.imgSrc2}
                    </div>
                    <h2 className='text-[40px] sm:text-[48px]  sm:mb-1 font-[700] lg:text-[40px] xl:text-[50px] xl:leading-[60px] xl:font-600 2xl:text-[50px] 2xl:leading-[70px] 2xl:font-[700] '>{item.value}</h2>

                    <div className="desc flex items-center justify-center sm:justify-left  text-[28px] leading-[42px] sm:text-xs xl:text-[16px] xl:leading-[20px] xl:font-thin 2xl:text-[20px] 2xl:leading-[20px] 2xl:font-thin">
                      {item.imgSrc}
                      <p className='text-[24px] sm:text-[15px] mb-5 sm:mb-0 2xl:text-[16px]'>{item.name}</p>
                    </div>
                  </div>
                ))
              }

            </div>

            <div className="emptyBox"></div>


          </div>
          <div className="bannerArt flex self-end  sm:mt-5 sm:w-full sm:justify-end hidden sm:hidden lg:block lg:w-[5rem] 2xl:w-[10rem] h-full absolute -top-5 right-0 xl:w-[7rem]">
            <img src={bannerArt} className="lg:h-[8rem] lg:w-full xl:h-[12rem] 2xl:h-[18rem] 2xl:w-full mr-0" alt="" />
          </div>
        </div>

        {/* section 2 */}
        <div className="section2 mt-10 sm:w-[40rem] md:w-[47rem] lg:w-[80vw] 2xl:w-[90rem] mx-auto py-8">
          <PageHeader titleText={"Innovative Gamified Hiring Platform to Empower Recruiters Like You"} />

          <div className="treeImage">
            <Stepper />
          </div>

          <div className="pricingBtn w-[200px] sm:w-[20rem] mx-auto mt-28  md:mt-20 lg:flex lg: justify-center sm:flex sm:justify-center">

            <Link to="/free">

              <StyledButton btnText={"START FREE TRIAL"} customStyle="!bg-[#ffd700] w-full h-[2rem] !text-[#333333] text-xs font-bold 2xl:font-semibold mb-[3rem]" />
            </Link>
          </div>

        </div>

        {/* banner 2 */}

        <div className="clientsBanner bg-[#333333]">

          <div className="banner2Wrapper sm:w-[40rem] lg:w-[80vw] mx-auto  flex flex-col lg:flex-row  lg:items-center py-5 items-center lg:justify-center lg:h-[260px] lg:pt-10  2xl:h-[500px]">


            <div className="left lg:mr-10 w-[20rem] sm:w-[40rem] lg:w-[43rem] text-center lg:text-left xl:w-[435px] 2xl:w-[575px] 2xl:mb-10">
              <h3 className='text-[24px] leading-[64px] sm:text-[2rem] text-[#ffd700] xl:text-[48px] xl:leading-[54px] xl:font-[700] 2xl:text-[58px] 2xl:font-[700] 2xl:leading-[60px] font-[700] lg:text-[28px] lg:leading-[29px] lg:font-[600]'>{toTitleCase("OUR CLIENTS")}</h3>
              <p className='text-white text-[16px] leading-[30px] sm:leading-[40px] sm:font-light 2xl:text-[21px] 2xl:leading-[37px] mt-3 lg:mt-[10px] lg:leading-[30px] xl:text-[18px] lg:text-[16px] xl:mt-[15px] 2xl:mt-[20px]'>Recruiting and talent acquisition teams from top companies partner with us to gamify their hiring process.</p>
            </div>
            <img src={window.innerWidth < 1024 ? brandBannerMobile : brandsBanner} className="sm:object-contain hidden sm:block w-[390px h-[700px] mt-5  sm:w-[20rem]  lg:h-[15rem] lg:w-[25rem] xl:object-contain xl:h-[236px] xl:w-[566px]  2xl:object-contain 2xl:h-[336px] 2xl:w-[660px] lg:mt-[17px] 2xl:mt-[0.5rem] xl:mt-[1.5rem]" alt="" />

            {/* </div> */}
          </div>
          <div className="carousels brandsSlides block sm:hidden pb-10">
            <Carousel images={brandsSlides} shuffleBy={1} />
          </div>
        </div>

        {/* Section 3 */}
        <div className="section2 hidden lg:block mt-5 px-10 w-full sm:w-[40rem] lg:w-[90vw] xl:mt-20 mx-auto pt-10 ">
          <PageHeader titleText={"What Sets Us Apart"} />

          <div className="treeImage mt-8 2xl:mt-20 ">
            <img src={window.innerWidth < 1024 ? curvedProcessMobile : curvedProcess} className="sm:object-contain h-[1649px] w-full sm:w-[20rem] sm:h-[1024px] lg:h-[18rem] lg:w-[60rem] xl:w-[70rem] mx-auto 2xl:w-[1712px] 2xl:h-[360px]" alt="" />
          </div>

        </div>


        {/* Section 4 */}
        <div className="section2 mt-5 w-screen sm:px-10 sm:w-[40rem] md:w-full lg:w-[90vw] xl:mt-28 mx-auto py-5 xl:py-2 2xl:mb-10 2xl:mt-40 ">
          <PageHeader titleText={"Here’s What Recruiters Have To Say"} customStyleContainer="px-10" />

          <div className="clientsReturns mt-0 lg:mt-5 xl:mt-5 xl:mb-[5rem]  2xl:mt-0 2xl:mb-20">

            <div className="desktopTestimonials hidden sm:block">
              <CustomTestimonialsComponent />
            </div>
            {/* : */}
            <div className="mobileTestimonials sm:hidden">
              <TestimonialsCarousel />
            </div>
            {/* } */}


          </div>
        </div>

        {/* last cta */}
        <div className="lastCTA bg-[#ffd700] sm:bg-[#333333] w-full mt-20 lg:mt-10 xl:mt-2">

          <div className="wrapper w-full h-[12rem] pb-4 sm:pb-0 flex-col-reverse sm:flex-col-reverse text-center sm:text-left  sm:w-[35rem] sm:h-[26rem] md:h-[510px]  lg:w-[60rem]  lg:h-full  px-5  mr-auto ml-auto flex 2xl:flex-row xl:w-[1057px]  2xl:w-[1257px] 2xl:h-full xl:h-full  lg:flex lg:flex-row">

            <div className="left mr-4 sm:m-0 mx-auto hidden sm:block xl:mr-10">
              <div className="mt-8 xl:mt-0  sm:mt-5 w-[290px]  lg:h-full lg:flex lg:items-center lg:w-[34rem]    xl:w-[550px] 2xl:w-[710px] sm:w-[400px] sm:h-[240px] md:w-[500px] md:h-[300px] sm:mx-auto ">
                <img src={upperFooterArt} className="sm:object-contain hidden sm:block " alt="" />
              </div>
            </div>
            <div className="right sm:mt-5   flex flex-col sm:items-center justify-center w-[290px] leading-[38px] lg:w-auto lg:h-auto sm:w-[20rem]  mx-auto xl:w-[400px] 2xl:w-[450px] lg:items-start md:h-[20rem] md:mt-2 xl:mt-5 ">
              <h3 className='text-[24px] sm:text-center sm:text-[1.5rem] lg:text-[24px] lg:leading-[40px] xl:w-[24rem] font-bold xl:text-[35px] 2xl:text-[44px] 2xl:leading-[55px] sm:text-xl 2xl:text-left lg:text-left lg:w-[24rem] text-[#333333] sm:text-white md:text-[2rem] md:leading-[2.1rem] 2xl:w-[27rem]'>Level-up Your Hiring Game Today!</h3>
              <div>

                <Link to="/free"> <StyledButton btnText={"START FREE TRIAL"} customStyle="w-[150px] sm:w-[10rem] 2xl:font-semibold xl:!font-semibold 2xl:leading-[36px]  2xl:h-[2rem] !text-sm mt-5 mx-auto sm:ml-0 !text-[12px] bg-[#ffd700] sm:!text-[#333333] sm:!mx-auto sm:mt-5 h-[2rem] 2xl:text-lg font-[700] xl:!text-sm xl:!h-[2rem] xl:!w-[12rem] lg:!text-sm lg:h-[2.5rem] sm:!h-[2rem] sm:!text-sm md:h-[2rem] md:!text-sm !bg-[#333333] sm:!bg-[#ffd700] xl:!h-[2rem] font-bold xl:!h-[2rem] 2xl:!h-[3.5rem] xl:mt-5 hover:!bg-white hover:!text-[#333333] hover:!font-semibold 2xl:!font-semibold 2xl:!text-[1.3rem] 2xl:!w-[15rem] 2xl:hover:!bg-white 2xl:hover:!text-[#333333] xl:hover:!bg-white xl:hover:!text-[#333333]" />
                </Link>
              </div>
            </div>
          </div>

        </div>

        {/* upper footer */}
        <div className="upperFooter  relative lg:w-full lg:mx-auto ">
          <svg className=' bottom-0 z-0 lg:left-0' viewBox="0 0 500 150" preserveAspectRatio="none" style={{ height: window.innerWidth > 1024 ? '14rem' : '8rem', width: '100%' }}><path d="M-3.76,53.79 C161.02,147.54 334.84,150.50 500.00,49.99 L500.00,0.00 L0.00,0.00 Z" style={{ stroke: 'none', fill: window.innerWidth < 640 ? '#ffd700' : '#F7F7F7' }} /></svg>

        </div>

      </div>
    </Layout>
  )
}

export default Home